// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import purchaseApprovalEntity from './entities/purchase-approval.json';
import purchaseApprovalMenu from '../pages/purchase-approval/menu.json';
import purchaseApprovalFullForm from '../pages/purchase-approval/forms/full.json';
import purchaseApprovalContextForm from '../pages/purchase-approval/forms/context.json';
import purchaseApprovalMiniForm from '../pages/purchase-approval/forms/mini.json';
import purchaseApprovalLookupForm from '../pages/purchase-approval/forms/lookup.json';
import purchaseApprovalTableView from '../pages/purchase-approval/views/table.json';
import purchaseApprovalCardsView from '../pages/purchase-approval/views/cards.json';
import purchaseApprovalCalendarView from '../pages/purchase-approval/views/calendar.json';
import purchaseApprovalDashboardView from '../pages/purchase-approval/views/dashboard.json';

/** Тип запису «Погодження закупівлі» зі сторінками пакета: меню, форми та подання з pages/purchase-approval/. */
export const purchaseApprovalDefinition: IRecordTypeDefinition = {
  ...purchaseApprovalEntity,
  views: assembleViewSet({
      table: purchaseApprovalTableView,
      cards: purchaseApprovalCardsView,
      calendar: purchaseApprovalCalendarView,
      dashboard: purchaseApprovalDashboardView,
  }),
  form: purchaseApprovalFullForm,
  forms: { full: purchaseApprovalFullForm, context: purchaseApprovalContextForm, mini: purchaseApprovalMiniForm, lookup: purchaseApprovalLookupForm },
  menu: purchaseApprovalMenu,
} as IRecordTypeDefinition;
